import styled from 'styled-components';

import colors from 'themes/Main';

const { gray01, gray02 } = colors;

export const PermissionGroup = styled.div`
  padding-bottom: 24px;
  position: relative;

  & + div {
    padding-top: 24px;
  }

  &:not(:last-child)::after {
    content: '';
    background-color: rgba(0, 0, 0, 0.1);
    bottom: 16px;
    height: 1px;
    left: 0;
    position: absolute;
    width: 100%;
  }
`;

export const GroupTitle = styled.p`
  color: ${gray01};
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 24px;
`;

export const Permission = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;

  p {
    color: ${gray02};
    margin-bottom: 0;
  }
`;

export const PermissionName = styled.div`
  align-items: center;
  display: flex;

  p {
    margin-right: 8px;
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;

  button + button {
    margin-left: 24px;
  }
`;
